import { useCallback } from 'react';
import { useTenantConfig } from './useTenantConfig.js';

function useTenantBehavior() {
  var _useTenantConfig;
  const {
    behaviors
  } = (_useTenantConfig = useTenantConfig()) !== null && _useTenantConfig !== void 0 ? _useTenantConfig : {};
  const getTenantBehavior = useCallback(name => behaviors === null || behaviors === void 0 ? void 0 : behaviors.find(behavior => behavior.name === name), [behaviors]);
  return getTenantBehavior;
}

export { useTenantBehavior };
//# sourceMappingURL=useTenantBehavior.js.map
